import { ColoursObj, Icon } from '@eventr/common-storybook'
import { FC } from 'react'
import { Marker } from 'react-map-gl/maplibre'
import { useShallow } from 'zustand/react/shallow'
import { useBoundStore } from '../../../../state/bound.store'
import LocationDot from '../components/locationDot'

export const ItineraryGeneralInfoMarker: FC = () => {
    const { getEventInfoV2 } = useBoundStore(
        useShallow((s) => ({
            getEventInfoV2: s.getEventInfoV2,
        }))
    )

    const v2 = getEventInfoV2()

    if (
        !v2 ||
        !v2.data ||
        !v2.data.OSMAddress ||
        !v2.data.OSMAddress.lon ||
        !v2.data.OSMAddress.lat
    ) {
        return null
    }

    return (
        <Marker
            key={'generalInfoMarker'}
            longitude={v2.data.OSMAddress.lon}
            latitude={v2.data.OSMAddress.lat}
        >
            <LocationDot
                diameter={40}
                backgroundColor={ColoursObj.backgrounds.secondary}
            >
                <Icon
                    name={'Itinerary'}
                    width="28px"
                    height="28px"
                    iconColour={ColoursObj.core.secondary}
                ></Icon>
            </LocationDot>
        </Marker>
    )
}
